import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie';


// auto-generated by the build process. If there is an error, run a build and it should go away.
import { getBuildInfo } from '../util/buildinfo';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ToastController } from '@ionic/angular';

@Injectable()
export class AppInfoService {
    
    svcVersion = {
        version: 'Loading...',
        online: true
    }

    constructor(private readonly httpClient: HttpClient, 
                private cookieService: CookieService, 
                public toastController: ToastController) {
        this.loadServerData();

        setInterval(this.loadServerData, 10000);
    }

    loadServerData = () => {
        this.svcBuildInfo().subscribe((svcVer: any) => {
            this.svcVersion = svcVer;
            const oldVersion = this.cookieService.get('svcVersion');
            this.svcVersion.online = true;
            var cookieExpDate = new Date();
            cookieExpDate = new Date(cookieExpDate.setDate(cookieExpDate.getDate() + 30));
            this.cookieService.put('svcVersion', svcVer.version, { 'expires':  cookieExpDate });
            
            //forces the window to refresh. 
            //update: it will wait for any registration to complete
            const inRegistration = window.location.href.includes('/register')
            const inGuestValuation = window.location.href.includes('/guest')
            if (inRegistration || inGuestValuation) {
                console.log('In guest pages, not refreshing to show video')
                return
            }
            if (!oldVersion ||  (oldVersion != svcVer.version)) {
                this.toastController.create({
                    message: 'There is a new version of the application, it will refresh shortly,',
                    duration: 6000,
                    position: 'top'
                  }).then(toast => {
                    toast.present();              
                  }) ;
                setTimeout(() => {
                    window.location.href = window.location.origin + '?reloadVersion=' + svcVer.version;
                }, 3000)
            }
        }, err => {
            this.svcVersion.version = 'VALUclick server is offline.'
            this.svcVersion.online = false;
        });

    }

	get webVersion() {
        return getBuildInfo();
	}

	svcBuildInfo() {
		return this.httpClient.get('auth/ping');
	}

    welcomeURL() {
        return this.httpClient.get('appservice/appvideo');
    }

}

